import {getMemberWalletBalance} from "../api/commonApi";
import {useEffect, useState} from 'react';
import {MemberWalletTypes} from "../types/member/member.wallet.types";
import {isLoggedIn} from "../utils/authUtils";

export const useMemberWallet = () => {

    //TODO: 회원 잔액 정보 및 기타 정보 조회 hook 입니다.
    const [memberWalletInfo, setMemberWalletInfo] = useState<MemberWalletTypes>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchWalletBalance = async () => {
        const isAuth = isLoggedIn();

        if (isAuth) {
            try {
                setLoading(true);
                setError(null);
                const response = await getMemberWalletBalance();
                if (response.data?.code === "00") {
                    setMemberWalletInfo(response.data.data);
                }
            } catch (err) {
                console.error('Failed to fetch getMemberWalletBalance:', err);
                setError('지갑 정보를 불러오는데 실패했습니다.');
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchWalletBalance();
    }, []);

    return {
        memberWalletInfo,
        loading,
        error,
        refetch: fetchWalletBalance
    };

};